import { useEffect, useCallback } from 'react';

import { EVENT_CHANGE_CONNECTED_TO_ROOM } from 'App/components/WebSocket';

import { useSocket } from '@gogame/sockets';

export const useSocketUpdateConnectedToRoom = (callbackOriginal, deps = []) => {
  const socket = useSocket();

  const callback = useCallback(
    (...props) => {
      callbackOriginal(...props);
    },
    [...deps]
  );

  useEffect(() => {
    socket.on(EVENT_CHANGE_CONNECTED_TO_ROOM, callback);
    return () => {
      socket.off(EVENT_CHANGE_CONNECTED_TO_ROOM, callback);
    };
  }, [socket, callback]);
};
